export { default } from './CLStyledTable'
